import React from 'react';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import PropTypes from 'prop-types';
import { FormElementMode } from './PropTypes';
/**
Label used for a Form Element Input that support a "view" and "edit" mode.
**/
const FormLabel = props => {
    const { mode = 'edit', required = false, label, additionalLabelText, fieldId, hideLabel = false, showAdditionalLabelTextInViewMode = false } = props;
    if (mode === 'view') {
        return React.createElement("span", Object.assign({}, resolve(props, 'label', hideLabel ? 'hidden' : null)),
            label,
            additionalLabelText && showAdditionalLabelTextInViewMode && React.createElement("span", Object.assign({}, resolve(props, 'additionalLabelText')), additionalLabelText));
    }
    return React.createElement(props.element, Object.assign({}, resolve(props, 'label', hideLabel ? 'hidden' : null), { htmlFor: fieldId }),
        React.createElement("span", Object.assign({}, resolve(props, 'labelText')),
            required && React.createElement("span", Object.assign({}, resolve(props, 'required')), "*\u00A0"),
            React.createElement("span", Object.assign({}, resolveTestId(props)), label)),
        additionalLabelText && React.createElement("span", Object.assign({}, resolve(props, 'additionalLabelText')), additionalLabelText));
};
FormLabel.propTypes = {
    /**
      Options are 'view' and 'edit'; default set to 'edit';
      When set to 'view', input will be rendered as passed in 'view' prop instead.
    */
    mode: FormElementMode,
    /** The ID of the element the label should be linked to. */
    fieldId: PropTypes.string.isRequired,
    /** Text to display for the label. */
    label: PropTypes.node,
    /** Additional text to display for the label. */
    additionalLabelText: PropTypes.node,
    /** Flag indicating whether to hide the label text. */
    hideLabel: PropTypes.bool,
    /** Flag indicating whether to show the additional label text in view mode. */
    showAdditionalLabelTextInViewMode: PropTypes.bool,
    /** Flag indicating whether the field is required. */
    required: PropTypes.bool,
    /** Available Style Keys. */
    style: PropTypes.shape({
        /** Top level style applied to the container. */
        label: PropTypes.object,
        /** Style applied to the primary label text. */
        labelText: PropTypes.object,
        /** Style applied to the additional label text. */
        additionalLabelText: PropTypes.object,
        /** Style applied to the label text and additional label text if it should be hidden. */
        hidden: PropTypes.object,
        /** Style applied to the required span if the required flag is set. */
        required: PropTypes.object
    }),
    /** html tag names, such as label, legend. Default is set to "label" */
    element: PropTypes.string
};
FormLabel.defaultProps = {
    element: 'label'
};
FormLabel.displayName = 'FormLabel';
export default FormLabel;
